import { z } from "zod";

export const numericIdParamSchema = z.coerce.number().int().positive();

export const organizationIdParamsSchema = z.object({
  organizationId: numericIdParamSchema,
});

export const contactSubmissionIdParamsSchema = z.object({
  contactSubmissionId: numericIdParamSchema,
});

export const classDayIdParamsSchema = z.object({
  classDayId: numericIdParamSchema,
});

export const semesterIdParamsSchema = z.object({
  semesterId: numericIdParamSchema,
});

export const familyIdParamsSchema = z.object({
  familyId: numericIdParamSchema,
});

export const roleIdParamsSchema = z.object({
  roleId: numericIdParamSchema,
});

export const classIdParamsSchema = z.object({
  classId: numericIdParamSchema,
});

export const applicationIdParamsSchema = z.object({
  applicationId: numericIdParamSchema,
});

export const enrollmentDetailParamsSchema = z.object({
  studentId: numericIdParamSchema,
  classDayId: numericIdParamSchema,
});

export const parseOrganizationIdParams = (params: { organizationId: string | number }) => {
  return organizationIdParamsSchema.parse(params);
};

export const parseContactSubmissionIdParams = (params: { contactSubmissionId: string | number }) => {
  return contactSubmissionIdParamsSchema.parse(params);
};

export const parseClassDayIdParams = (params: { classDayId: string | number }) => {
  return classDayIdParamsSchema.parse(params);
};

export const parseSemesterIdParams = (params: { semesterId: string | number }) => {
  return semesterIdParamsSchema.parse(params);
};

export const parseFamilyIdParams = (params: { familyId: string | number }) => {
  return familyIdParamsSchema.parse(params);
};

export const parseRoleIdParams = (params: { roleId: string | number }) => {
  return roleIdParamsSchema.parse(params);
};

export const parseClassIdParams = (params: { classId: string | number }) => {
  return classIdParamsSchema.parse(params);
};

export const parseApplicationIdParams = (params: { applicationId: string | number }) => {
  return applicationIdParamsSchema.parse(params);
};

export const parseEnrollmentDetailParams = (params: { studentId: string | number; classDayId: string | number }) => {
  return enrollmentDetailParamsSchema.parse(params);
};
